import { URL_API } from "@/config";
import { tokenDecrypted } from "@/utils/decryptToken";
import { url } from "@/utils/urlParam";
import axios from "axios";

export const GeneratePayslipAPI = async (query) => {
  try {
    const response = await axios.post(
      `${URL_API}/payrun${query}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${tokenDecrypted()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error.response;
  }
};
export const GetPayslipAPI = async ({ companyId, periodicId }) => {
  try {
    const params = new URLSearchParams(url.search);
    if (companyId) {
      params.append("company_id", companyId);
    }

    if (periodicId) {
      params.append("periodic_id", periodicId);
    }
    const { data } = await axios.get(`${URL_API}/payrun?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });
    return {
      success: true,
      message: "",
      data: data.data,
    };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: [],
    };
  }
};
export const GetPeriodicActiveAPI = async (query) => {
  try {
    const response = await axios.get(`${URL_API}/periodic/status${query}`, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};
export const ChangeStatusPeriodicAPI = async (id) => {
  try {
    const response = await axios.put(
      `${URL_API}/periodic/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${tokenDecrypted()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error.response;
  }
};
export const EditPayrunStatusAPI = async (id, query) => {
  try {
    const response = await axios.put(
      `${URL_API}/payrun/${id}${query}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${tokenDecrypted()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error.response;
  }
};
export const RecalculatePayrunAPI = async (id) => {
  try {
    const response = await axios.put(
      `${URL_API}/payrun/recalculate/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${tokenDecrypted()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error.response;
  }
};
export const EditPayrunDataAPI = async (id, data) => {
  try {
    const response = await axios.put(
      `${URL_API}/payrun/data/${id}`,
      { ...data },
      {
        headers: {
          Authorization: `Bearer ${tokenDecrypted()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error.response;
  }
};
export const UploadPDFFileAPI = async (data, id) => {
  try {
    const response = await axios.post(
      `${URL_API}/payrun/upload-pdf/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${tokenDecrypted()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error.response;
  }
};
export const generatePDFFile = async ({ id, payload }) => {
  try {
    const { data } = await axios.post(
      `${URL_API}/payrun/create-pdf/${id}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${tokenDecrypted()}`,
        },
      }
    );

    return { success: true, message: "", data: data };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: [],
    };
  }
};

export const downloadPDFFile = async ({ id }) => {
  try {
    const { data } = await axios.get(`${URL_API}/payrun/download-pdf/${id}`, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });
    console.log(data);
    return { success: true, message: "", data: data };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: [],
    };
  }
};
